'use strict' ;

function QuoteResultFilter() {
	return {
		filter : function(filter, list) {
			if ( !filter) return list;

			var filteredList = list.filter(function(quoteResult) {
				return !filter.displayCover || filter.displayCover[quoteResult.coverType] === true ;
			});

			if ( !!filter.displayOffering ) {
				filteredList = filteredList.filter(function(quoteResult) {
					return ! filter.displayOffering || filter.displayOffering[quoteResult.offering] === true ;
				});
			}

			var orderedList = filteredList.sort(function(cover1, cover2) {
				if ( filter.order && filter.order.orderByPrice ){
					var cover1Bigger = cover1.totalPremium > cover2.totalPremium ;
					return filter.order.cheapestFirst ? cover1Bigger : ! cover1Bigger ;
				}
				return 0;
			})

			return orderedList;
		}
	}
}
